import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditResourceCategory = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Resource Category'
      fields={fields}
      apiPath={`admin/resource_categories/${props.params.resourceCategoryId}`}
      successRedirectPath='/write-now/resource_categories'
      buildMenuItems={menuItems}
    />
  )
}

export default EditResourceCategory
